import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysFinanceHistoryRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const snapshot = await this.reimaginedData.fetchFinancialSnapshot();
    return { snapshot };
  }
}
